module.exports = __webpack_public_path__ + "assets/img/roles.a6001bb9.svg";